import React from 'react';
import { AgenciesList } from '../../components/Views/AgenciesPage';
import { getSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import { agenciesQuery } from '../../api/queries';
import initApollo from '../../utils/init-Apollo';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import { getStaticData } from '../../utils/helpers/getStaticData';
import { getSSRContextData } from '../../utils/helpers/ssrContext';
import { withBugsnagGetServerSideProps } from '../../utils/withBugsnag';
import { readMockFile } from '../../utils/helpers/readMockFile';

const Agencies = props => <AgenciesList {...props} />;

export const getServerSideProps = withBugsnagGetServerSideProps(
  async ({ req, query }) => {
    const { platform } = getSSRContextData(req);
    const currentLang = getLocaleOnSSR(req);

    const apolloClient = initApollo({}, { lang: currentLang, platform });
    const asPath = '/agentlikler';

    if (
      (query.mock === 'true' || process.env.NEXT_PUBLIC_E2E === '1') &&
      process.env.NODE_ENV !== 'production'
    ) {
      const mock = await readMockFile('agenciesMockData.json');

      return { props: { agencies: mock.data.agencies } };
    }

    const [seoData, agenciesRes, staticData] = await Promise.all([
      getSeoData(apolloClient, asPath, req, true),
      apolloClient.query({
        query: agenciesQuery,
        fetchPolicy: 'no-cache'
      }),
      getStaticData(apolloClient)
    ]);

    return {
      props: {
        seoData,
        ...staticData,
        agencies: agenciesRes?.data?.agencies || [],
        hasError: false,
        currentLang
      }
    };
  },
  '/agencies',
  {
    seoData: {},
    keywords: [],
    citiesUnPopularList: [],
    regions: {},
    agencies: [],
    hasError: true
  }
);

Agencies.getLayout = (page, pageProps) => (
  <Layout
    isBottomNavigation
    isShowCloseButton={false}
    pageProps={pageProps}
    hideMobileHeader
  >
    {page}
  </Layout>
);

export default Agencies;
